import React from "react";
import { Button } from "antd";

import { countriesAttributes } from "../constants/countriesAttributes";
import { URL_SCHEME, MELI_APP_SCOPES } from "../constants/environments";

const authMercadoPagoAccount = (countryCode) => {
  const clientId = countriesAttributes.find(
    (country) => country.code === countryCode
  ).mp_app_id;
  if (countryCode === "CL") {
    window.location = `${URL_SCHEME}auth.mercadopago.${countryCode}/authorization?client_id=${clientId}&response_type=code&platform_id=mp&scopes=${MELI_APP_SCOPES}`;
  } else {
    window.location = `${URL_SCHEME}auth.mercadopago.com.${countryCode}/authorization?client_id=${clientId}&response_type=code&platform_id=mp&scopes=${MELI_APP_SCOPES}`;
  }
};

export const MercadoPagoAuthButtom = ({ countryCode }) => {
  return (
    <div className="button-container">
      <Button
        type="primary"
        onClick={() => authMercadoPagoAccount(countryCode)}
      >
        Seleccionar
      </Button>
    </div>
  );
};
